// extracted by mini-css-extract-plugin
export default {"tooltip":"PanelSelection_tooltip__Cthch","modalContainer":"PanelSelection_modalContainer__-nsNz"};